import React from "react"

import Page from "../components/Page"
import Tile from "../components/Tile"
import Quote from "../components/Site/Quote"
import data from "../data/Home"
import Paragraph from "../components/Site/Paragraph"
import Logo from "../assets/images/logo.png"

const Home = () => (
  <Page title="główna">
    <section className="section">
      <p className="section-eyebrow">Nasza oferta</p>
      <h2 className="section-title">W czym możemy pomóc?</h2>
      <div className="cards">
        {data.offer.map((item) => (
          <Tile key={item.url} {...item} />
        ))}
      </div>
    </section>
    <section className="info-box">
      <div className="info-logo-wrapper">
        <img src={Logo} className="info-logo" alt="Logo D&M Accountancy Services" />
      </div>
      <div className="info-text">
        {data.info.map((item, index) => {
          return item.type === "paragraph" ? (
            <Paragraph key={index} text={item.text} />
          ) : (
            <Quote key={index} text={item.text} fontSize={item.fontSize} />
          )
        })}
      </div>
    </section>
  </Page>
)

export default Home
